import { IEnvironment } from './environment.type';

export const environment: IEnvironment = {
    idleTimeout: 10 * 60 * 60 * 1000, // 1 hour in milliseconds
    production: false,
    firebaseConfig: {
        apiKey: 'AIzaSyA2C-hbIp63rQW4EFPw0GZaTh0MvZHy0Ic',
        authDomain: 'enecams-f725d.firebaseapp.com',
        projectId: 'enecams-f725d',
        storageBucket: 'enecams-f725d.firebasestorage.app',
        messagingSenderId: '299390466288',
        appId: '1:299390466288:web:15abdff3a264b0ecf72a35',
        measurementId: 'G-11EYH9YT60',
        vapidKey:
            'BISILTQBTSS_iPkpkiqbUYfmBetcdtElecxtCdFoGcwvcXLJn6lQy-CggFRvjDv8uHaiYnSSx6SLkR-Yd2ru0Js',
    },
    azure: {
        clientId: '76c0150b-da50-4513-b57a-ab3a3a82b888',
        tenantId: 'ccc390ec-8f2c-4fe5-8ae9-da6e94c11201',
        authority: 'https://login.microsoftonline.com/ccc390ec-8f2c-4fe5-8ae9-da6e94c11201',
        redirectUri: 'https://enecstg.ucglab.com/verify-user',
    },
    apiBaseUrl: 'https://enecstg.ucglab.com/api',
};
